import React from 'react';

import { IconButton, useTheme } from '@mui/material';
import { exitIcon, FaOptionIcon } from '@europrocurement/l2d-icons';
import { useFullLayout } from '../../templates/FullLayout/FullLayoutContext';

export const CloseSidebarButton: React.FunctionComponent = function () {
    const { isSidebarOpen, setSidebarOpen } = useFullLayout();
    const { palette } = useTheme();

    return (
        <>
            {/* Pour le mode Desktop */}
            <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => setSidebarOpen(!isSidebarOpen)}
                size="small"
                sx={{
                    display: {
                        lg: 'flex',
                        xs: 'none',
                    },
                }}
            >
                <FaOptionIcon
                    icon={exitIcon.props.icon}
                    size="lg"
                    color={palette.text.secondary}
                    iconProps={{
                        transform: isSidebarOpen ? 'rotate-180' : 'rotate-0',
                    }}
                />
            </IconButton>

            {/* Pour le Mobile */}
            <IconButton
                size="small"
                color="inherit"
                aria-label="menu"
                onClick={() => setSidebarOpen(!isSidebarOpen)}
                sx={{
                    display: {
                        lg: 'none',
                        xs: 'flex',
                    },
                }}
            >
                <FaOptionIcon
                    icon={exitIcon.props.icon}
                    size="lg"
                    sx={{
                        width: '24px',
                        height: '24px',
                    }}
                    iconProps={{
                        transform: isSidebarOpen ? 'rotate-180' : 'rotate-0',
                    }}
                />
            </IconButton>
        </>
    );
};
